<ng-dialog-header title="Completion comments"></ng-dialog-header>
<div mat-dialog-content>
  <div *ngIf="!loading; else spinnerTemplate" class="container">
    <form [formGroup]="fg">
      <mat-form-field appearance="outline" class="w-100" color="accent">
        <mat-label ngRequired>Reason</mat-label>
        <textarea formControlName="reason" matInput maxlength="1000" ngTrim rows="4" type="text"></textarea>
      </mat-form-field>
    </form>
  </div>
</div>
<ng-dialog-footer class="d-flex justify-content-end w-100">
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-stroked-button mat-dialog-close class="mx-3" aria-label="Cancel" color="warn">Cancel</button>
    <button mat-flat-button color="accent" aria-label="OK" [disabled]="fg.invalid"
            (click)="completeDiversion.emit(fg.get('reason')!.value)">OK
    </button>
  </div>
</ng-dialog-footer>

<ng-template #spinnerTemplate>
  <div class="d-flex flex-fill justify-content-center align-self-center">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
  </div>
</ng-template>
